let lastUniquePositiveId = 0;
let lastUniqueNegativeId = 0;

function getPositiveUniqueId() {
  return ++lastUniquePositiveId;
}

function getNegativeUniqueId() {
  return --lastUniqueNegativeId;
}

export function useUniqueIds() {
  return {
    getPositiveUniqueId,
    getNegativeUniqueId
  };
}
